module.exports = __webpack_public_path__ + "static/media/WhenYouWishUponaLanternBookJacket.be9fc753.jpg";